import $ from 'jquery';
import axios from "axios";
import { initProductTileItem } from "./basket";

$(function() {

    initHeaderSearch();

});


let headerSearchTerm = '';
let searchTimer = null;

// Functions handling the search box in the header
function initHeaderSearch() {

    $('#header-search').on('keyup', function(e) {

        let newSearchTerm = $(this).val();

        if ((e.which === 13) && (newSearchTerm !== '')) {
            // Enter pressed - redirect to the search results page
            clearTimeout(searchTimer);
            e.stopPropagation();
            window.location.href = '/search?for=' + newSearchTerm;
            return;
        }

    });


    $('#header-search').on('input', function(e) {

        let newSearchTerm = $(this).val();

        // No need to do anything if the search term hasn't changed
        if (newSearchTerm === headerSearchTerm) {
            return;
        }

        // Set the new search term
        headerSearchTerm = newSearchTerm;

        if (headerSearchTerm === '') {
            $('.header-search-wrapper .fa-circle-xmark').addClass('hide');
            clearSearchResults();
            return;
        }

        $('.header-search-wrapper .fa-circle-xmark').removeClass('hide');

        // Check if the search term is long enough to be bothered with - minimum 3 characters perhaps?
        if (headerSearchTerm.length < 3) {
            return;
        }

        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => {
            runSearch(headerSearchTerm);
        }, 250);

    });

    $('#header-search').on('change', function(e) {
        console.log('change');
        if ($(this).val() === '') {
            $('.header-search-wrapper .fa-circle-xmark').addClass('hide');
        } else {
            $('.header-search-wrapper .fa-circle-xmark').removeClass('hide');
        }
    });

    $('#header-search').on('mouseover', function(e) {
        if ($(this).val() != '') {
            $('.header-search-wrapper .fa-circle-xmark').removeClass('hide');
        }
    });

    $('#header-search').on('mouseout', function(e) {
        if ($(this).val() === '') {
            $('.header-search-wrapper .fa-circle-xmark').addClass('hide');
        }
    });

    $('.header-search-wrapper .fa-circle-xmark').on('click', function() {
        $('#header-search').val('');
        $('.header-search-wrapper .fa-circle-xmark').addClass('hide');
        clearSearchResults();
    });

}

function runSearch(searchTerm) {

    // Not sure that we really need this, should be taken care of by the searchTimer debounce
    // but doesn't hurt perhaps ...
    if (searchTerm !== headerSearchTerm) {
        return;
    }

    let $searchResultsWrapper = $('#search-results-wrapper');

    if (!$searchResultsWrapper.hasClass('show')) {
        let headerTop = $('header').position().top;
        $searchResultsWrapper.css('top', headerTop + 'px');
        $searchResultsWrapper.addClass('show');
    }

    // Run the search
    axios.get('/quicksearch?for=' + headerSearchTerm, {})
        .then(function (response) {
            if (typeof response.data === 'string') {
                $searchResultsWrapper.find('.search-results-outer').remove();
                $searchResultsWrapper.find('.search-results-outer-searching').addClass('hide');
                $searchResultsWrapper.append(response.data);
                // Enable the add buttons
                initSearchResults();
            } else {
                console.log(response);
            }
        })
        .catch(function(error) {
            console.log(error);
        });

}

function initSearchResults() {

    $('#search-results-wrapper .close i').on('click', function() {
        clearSearchResults();
        $('#header-search').val('');
        headerSearchTerm = '';
    });

    $(window).scroll(function() {
        let st = $(this).scrollTop();
        let $checkoutBar = $('.checkout-bar').first();
        if ((st === 0) && ($checkoutBar)) {
            $('#search-results-wrapper').css('top', $checkoutBar.height() + 'px');
        } else {
            $('#search-results-wrapper').css('top', '0');
        }
    });

}


function clearSearchResults() {
    $('#search-results-wrapper').removeClass('show');
    $('#search-results-wrapper .search-results-outer').remove();
    $('#search-results-wrapper .search-results-outer-searching').removeClass('hide');
    //$('#search-results-wrapper').html('');
}
